import { getPrinters } from "@api/PrintNode"
import Localization from "@localization/Index"
import { PageStates } from "@utils/PageStateUtils"
import { useEffect, useState, useContext } from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { PackagingConfiguratorContext } from "./PackagingConfigurator"

const PrintNodeManager = () =>{
    const packagingConfiguratorContext = useContext(PackagingConfiguratorContext)
    
    const { selectedStandardPrinterId, selectedServicePrinterId, selectedZebraPrinterId, printNodePrinterListState } = packagingConfiguratorContext
    const [printNodePrinterList, setPrintNodePrinterList] = printNodePrinterListState

    const [componentState, setComponentState] = useState<PageStates>(PageStates.INIT)
    
    const getStatus = async()=>{
        try{
            setComponentState(PageStates.LOADING)
            const printers = await getPrinters([selectedZebraPrinterId, selectedStandardPrinterId, selectedServicePrinterId].filter(id=>id!==undefined) as string[])
            const zebra = printers.find(p=>p.id === selectedZebraPrinterId)
            const standard = printers.find(p=>p.id === selectedStandardPrinterId)
            const service = printers.find(p=>p.id === selectedServicePrinterId)

            setPrintNodePrinterList(prev=>{
                if(prev===undefined) return prev

                const curr = [...prev]
                const currZebra = curr.find(printer=>printer.id === selectedZebraPrinterId)
                const currStandard = curr.find(printer=>printer.id === selectedStandardPrinterId)
                const currService = curr.find(printer=>printer.id === selectedServicePrinterId)
                if(currZebra && zebra?.state) { currZebra.state = zebra.state}
                if(currStandard && standard?.state) { currStandard.state = standard.state}
                if(currService && service?.state) { currService.state = service.state}
                return curr
            })

            return setComponentState(PageStates.IDLE)
        } catch(err) {
            setComponentState(PageStates.IDLE)
        }
    }
    
    const getStatusFromPrinter = (id?: string) =>{
        if(!id) {
            return {variant: "muted", tooltip: ""}
        }
        if(componentState === PageStates.LOADING) {
            return {variant: "warning", tooltip: Localization.ATTENDERE}
        }
        const printer = printNodePrinterList?.find(printer=>printer.id === id)
        if(!printer) {
            return {variant: "muted", tooltip: ""}
        }
        if(printer.state === "online") {
            return {variant: "success", tooltip: "Online"}
        }

        return {variant: "danger", tooltip: printer.state}
    }
    
    useEffect(()=>{
        getStatus()
    }, [selectedZebraPrinterId, selectedStandardPrinterId, selectedServicePrinterId])
    
    const zebraStatus = getStatusFromPrinter(selectedZebraPrinterId)
    const standardStatus = getStatusFromPrinter(selectedStandardPrinterId)
    const serviceStatus = getStatusFromPrinter(selectedServicePrinterId)
    
    const zebraTooltip = zebraStatus.tooltip?(
        <Tooltip id="zebra_printnode_tooltip" style={{position:'fixed'}}>
            {zebraStatus.tooltip}
        </Tooltip>
    ):<></>

    const standardTooltip = standardStatus.tooltip?(
        <Tooltip id="<standard_printnode_tooltip" style={{position:'fixed'}}>
            {standardStatus.tooltip}
        </Tooltip>
    ):<></>

    const serviceTooltip = serviceStatus.tooltip?(
        <Tooltip id="service_printnode_tooltip" style={{position:'fixed'}}>
            {serviceStatus.tooltip}
        </Tooltip>
    ):<></>

    
    return <div role="button" className="d-flex justify-content-end align-items-center"  onClick={()=>getStatus()}>
                <OverlayTrigger placement="top" overlay={zebraTooltip}>
                    <div className="d-flex justify-content-start align-items-center mx-3" role="button">
                        <img className="me-2" src="/zebra/zebra_small.jpeg" alt="Zebra" style={{height: '2.5rem'}} />
                        <i className={`bi-circle-fill text-${zebraStatus.variant} ${zebraStatus.variant==='warning'?"loading-skeleton":""}`} />
                    </div>
                </OverlayTrigger>
                <OverlayTrigger placement="top" overlay={standardTooltip}>
                    <div className="d-flex justify-content-start align-items-center mx-3" role="button">
                        <i className="bi-printer font-2x text-muted me-2" />
                        <i className={`bi-circle-fill text-${standardStatus.variant} ${standardStatus.variant==='warning'?"loading-skeleton":""}`} />
                    </div>
                </OverlayTrigger>
                <OverlayTrigger placement="top" overlay={serviceTooltip}>
                    <div className="d-flex justify-content-start align-items-center mx-3" role="button">
                        <i className="bi-gear font-2x text-muted me-2" />
                        <i className={`bi-circle-fill text-${serviceStatus.variant} ${serviceStatus.variant==='warning'?"loading-skeleton":""}`} />
                    </div>
                </OverlayTrigger>
            </div>
}

export default PrintNodeManager